'use client'
import { Button, ButtonVariants } from '../../../atoms'
import { ChevronDownIcon } from '../../../icons'
import React from 'react'
import { TableCell } from './TableCell'
import { useTableContext } from '../../../../providers'

interface CollapseRowCellProps {
    isCollapsed: boolean
    hasContent: boolean
    toggleIsCollapsed: () => void
}

export const CollapseRowCell = ({ isCollapsed, hasContent, toggleIsCollapsed }: CollapseRowCellProps): JSX.Element => {
    const { columns } = useTableContext()

    return (
        <TableCell column={columns.at(-1)}>
            {hasContent && (
                <Button
                    icon={<ChevronDownIcon className={`transition-transform ${isCollapsed ? '' : 'rotate-180'}`} />}
                    variant={ButtonVariants.QUIET}
                    onClick={() => toggleIsCollapsed()}
                    data-testid="toggle-collapse-button"
                />
            )}
        </TableCell>
    )
}
